import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { AuthService } from '../../core/auth.service';
import { BaseService } from '../../shared/base.service';
import { DomainsModel } from './domains.model';
import { AppService } from '../../app.service';
import { DialogComponent } from '../../dialog/dialog.component';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { ServiceProviderSettingComponent } from '../../service-provider-setting/service-provider-setting.component';
import { ServiceProviderSettingService } from '../../service-provider-setting/service-provider-setting.service';

@Component({
    selector: 'domains-component',
    templateUrl: './domains.component.html',
    styleUrls: ['./domains.component.scss'],
    providers: [BaseService, ServiceProviderSettingService]
})

export class DomainsComponent extends ServiceProviderSettingComponent implements OnInit, AfterViewInit {
    @ViewChild('dialogLogo', { static: false }) dialogLogo: DialogComponent;
    @ViewChild('modalDeleteDomain', {static: false}) modalDeleteDomain: ModalDirective;

    helpDomainProfile: any;
    readonly tableColumns = [
        ['id', 'ID', 'col-xs-1 id-header' , 'customer_id', 'default'],
        ['name_', 'Domain Name', 'col-xs-5', 'name', 'default'],
        ['se_name_', 'Self evaluation name', 'col-xs-5', 'name', 'default'],
        ['scientific', 'Scientific', 'col-xs-1', 'scientific', 'boolean'],
    ];

    items: any;
    totalItems = 0;
    deletingDomain: any;
    parentItem = 0;
    itemLanguage: string;

    constructor(public authService: AuthService,
                public router: Router,
                public baseService: BaseService,
                public appService: AppService,
                public route: ActivatedRoute,
                public translate: TranslateService,
                public fb: FormBuilder,
                public serviceProviderService: ServiceProviderSettingService) {
        super(authService, router, baseService, appService, fb, serviceProviderService);
    }

    ngOnInit() {
        super.ngOnInit();
        super.itemsPerPage = -1;
        this.sortedColumn = 'parent_id';
        this.searchInfo = new DomainsModel();
        this.url = 'self-report-setting/domains';
        this.token = this.authService.user['token'];
        this.itemLanguage = 'de_CH';
        this.languages = JSON.parse(localStorage.getItem('languages'));
    }

    ngAfterViewInit(): void {
        this.initAction();
        super.deleteModal = this.modalDeleteDomain;
    }

    initFormDataToModal(form, response, params){
        if (this.form != null) {
            this.form.reset(form);
        } else {
            this.form = this.fb.group(form);
            this.languages.forEach(language => {
                this.form.controls['name_' + language['locale']].setValidators([<any>Validators.required, <any>Validators.minLength(3)]);
                this.form.controls['name_on_cv_map_' + language['locale']].setValidators([<any>Validators.required, <any>Validators.minLength(3)]);
                this.form.controls['name_on_se_map_' + language['locale']].setValidators([<any>Validators.required, <any>Validators.minLength(3)]);
                this.form.controls['se_name_' + language['locale']].setValidators([<any>Validators.required, <any>Validators.minLength(3)]);
            });
            this.form.controls['scientific'].setValidators([<any>Validators.required]);
            this.form.controls['show_on_map'].setValidators([<any>Validators.required]);
        }

        if (params['action'] === 'create') {
            this.form.controls['show_on_map'].setValue(1);
            this.form.controls['scientific'].setValue(1);
        } else if (params['action'] === 'update') {
            this.form.controls['parent_id'].disable();
        }
    }

    checkParent(domain){
        if(!domain['parent']){
            return false;
        }
        const parent = domain['parent'];
        if(parent['id'] === this.parentItem){
            return false;
        }
        this.parentItem = parent['id'];
        return parent['id'];
    }
}
